@if (editMode) {
  <div></div>
}
@if (!editMode) {
  <div>
    <div
      class="status"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px">
      <div>
        <img src="/assets/images/files/Filetype_XLS.svg" />
      </div>
      <div class="title">
        {{ controlDisplay }}
      </div>
    </div>
  </div>
}
